// Entry point for HelpCenterEngine JavaScript
console.log("HelpCenterEngine JavaScript loading...")
import { Application } from "@hotwired/stimulus"
import RedactorController from "./controllers/redactor_controller.js"
import TomselectController from "./controllers/tomselect_controller.js"
import SearchController from "./controllers/search_controller.js"

// Import Tailwind CSS
import "../../assets/stylesheets/help_center_engine/tailwind.css"

// Import Tom Select CSS
import "tom-select/dist/css/tom-select.css"

console.log("Starting Stimulus application...")
const application = Application.start()
console.log("Stimulus application started:", application)

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import and register controllers
application.register("redactor", RedactorController)
application.register("tomselect", TomselectController)
application.register("search", SearchController)

export { application }
